import React from 'react'
import HeroTwo from '../components/heroTwo/HeroTwo'
import scratch from '../assets/scratch-intermediate.png'
import { Link } from 'react-router-dom'
import arrow from '../assets/arrow.svg'

export default function Blog2() {
    return (
        <div className='blog__container'>
        <HeroTwo 
        head='Blog 2'
        />
        <div className="main__blog">
        <div className="main__img">
            <Link className="paragraph" to='/blog' >
                 <img src={arrow} alt="" />
                  Back to Blog page
            </Link>
            </div>
            <div className="body__blog">
                    <div className="blog__img">
                        <img src={scratch} alt="" />
                    </div>
                    
                <div className="text__blog">

                    <h2>WHAT IS SCRATCH?</h2>
                    <p className='paragraph'>Scratch was designed at the famous Lifelong Kindergarten Group at the MIT Media Lab, which pioneered the whole idea of teaching programming to kids in the early 1980s through their first kid-friendly language called Logo. It requires kids to drag and drop blocks as if they are building Lego blocks. Scratch also embeds many of the standard Computer Science concepts and even a few advanced concepts like concurrency and object-oriented thinking. 
                    </p>
                    <p className='paragraph'>
                        Scratch make students interested in the process of thinking, analyzing and debugging their own thought process. Children who use scratch enjoy coding over and over again without getting tired or frustrated and love to share their working programs enthusiastically with their family and friends.
                    </p>
                    <p className='paragraph'>
                    Scratch helps young people learn to think creatively, reason systematically, and work collaboratively. These are all essential skills for life in the 21st century. Scratch can be used to create interactive stories, games and animations. It also provides an online community where people can share their work with others and also learn from the projects done by others.
                    </p>
                    <p>Some useful links:</p>
                    <ol>
                        <li className="paragraph">
                        Scratch website; <a href="https:/scratch.mit.edu/" rel='noreferrer' target="_blank"> https:/scratch.mit.edu/ </a>
                        </li>
                        <li className="paragraph">
                        Download Scratch  offline app; <a href= 'https://scratch.mit.edu/download' target="_blank" rel='noreferrer'>https://scratch.mit.edu </a>
                        </li>
                        <li className="paragraph">
                        Scratch junior app; <a href="https://www.scratchjr.org/" rel='noreferrer' target="_blank">https://www.scratchjr.org/
                        </a> 
                        </li>
                        <li className='paragraph'>
                        Learning Computer Science without computer;
                        <a href="https://csunplugged.org/en/" rel='noreferrer' target="_blank"> https://csunplugged.org/en/ </a>

                        </li>
                    </ol>
                  
                </div>
                

            </div>
          
            
        </div>

    </div>
    )
}
